<template>

  <div id="app">
    <div >
      <search-bar  ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">
          <div slot="search-tool">
            <!--  <el-button class="item-btn" @click="exportQuery">导出</el-button> -->
              <el-button class="item-btn c-btn-sub" @click="clearQuery">重置</el-button>
              <!-- <el-button size="mini" type="primary" @click.native='uploadDialolg =true'>点击上传</el-button> -->
              <!-- <el-button class="item-btn" type="primary" @click="getList">查 询</el-button> -->
          </div>
          <div slot="search-cont">

              <div class="item">
                <div class="item-label">用户状态</div>
                <el-select v-model="oastatus"  size="small" slot="prepend" placeholder="请选择用户状态" @change="getAdmin" style="130px">
                  <el-option label="不限" value=""></el-option>
                  <el-option label="在职" value="2"></el-option>
                  <el-option label="离职" value="3"></el-option>
                </el-select>
              </div>

              <div class="item" >
                <div class="item-label">关键词搜索</div>
                <div style="width: 300px;" >
                  <el-input placeholder="请输入内容" v-model="key" class="input-with-select" size="small" @keyup.enter.native='searchResume'>
                    <el-select v-model="key_type" slot="prepend" placeholder="请选择" @change="selectChange" style="width: 130px" size="small">
                      <el-option label="用户名" value="1"></el-option>
                      <el-option label="电话" value="2"></el-option>
                      <!-- <el-option label="到账审批人" value="6"></el-option>
                      <el-option label="还款审批人" value="7"></el-option> -->
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="item">
                <div class="item-label">所属部门</div>

                <el-select size="small" v-model="department" @change="getAdmin">
                  <el-option
                    v-for="(item, index) in departmentList"
                    :key="index"
                    :value="String(item.id)"
                    :label="item.name"

                    >{{ item.name }}</el-option>
                </el-select>
              </div>
              <!--  操作按钮 start -->
                <div class="item">
                  <el-button class="item-btn" type="primary" @click="getAdmin">查询</el-button>
                  <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
                </div>
              <!--  操作按钮 end -->


          </div>
      </search-bar>
    <div class="operation-tool">
        <div @click="handleEdit('')" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加内部员工</div>
      </div>
  <div class="l-panel">
        <div class="panel-body">
      <el-table class="l-table" stripe="" :data="adminList" style="width: 100%" @selection-change="handleSelectionChange" size="mini">

            <el-table-column prop="oausername" label="用户名" align="left" width="120"> </el-table-column>
            <el-table-column prop="oamobile" label="电话" align="left"> </el-table-column>
            <el-table-column prop="email" label="邮箱" align="left"> </el-table-column>
            <el-table-column prop="qq" label="qq" align="left" > </el-table-column>
            <el-table-column prop="oaentrytime" label="入职时间" align="left"> </el-table-column>
            <el-table-column  prop="oastatus" label="用户状态" align="left" >
              <template slot-scope='{row}'>
                <span v-if="row.oastatus == 2">在职</span>
                <span v-if="row.oastatus == 3">离职</span>
              </template>
            </el-table-column>
            <el-table-column  prop="department" label="部门" align="left">
            </el-table-column>

            <el-table-column  prop="oajobname" label="工作职位" align="left">
              <template slot-scope="{row}">
                  <el-link @click="goEnterprisePosition(row)">{{row.oajobname}}</el-link>
              </template>
            </el-table-column>
            <el-table-column  prop="oaplace" label="工作地点" align="left"></el-table-column>
            <el-table-column  prop="date" label="操作" align="center" >
               <template slot-scope="{row}">

                 <el-button type="primary" size="mini" @click="handleEdit(row.id)"><i class="el-icon-edit-outline"></i>编辑</el-button>

               </template>
            </el-table-column>

          </el-table>
          <div class="c-table-pager">
                <el-pagination  @current-change="handleCurrentChange" :total="total">
                </el-pagination>
          </div>
        </div>
    </div>


    </div>

  </div>

</template>

<script>
  import { WebUrl } from '@/api/index';
  import Message from '@/utils/message.js';
  export default{
    data:function(){
      return {
      oastatus:'2' ,//默认查在职
      adminList:[],
      oatype:'' ,
      key:'',   //关键字搜索
      key_type:'', //关键字类型：
      department:"",//部门id
      page:1,   //页码
      total:1,
      myHeaders:{},
      fileList:[],
      host:process.env.API_ROOT,
      id:'',
      yoes2: {

      },
      uploadData:{type:'zp'},
      departmentList:[]

      }
    },
    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=false");
          });
    },
    mounted() {
      if(this.$route.query.departName && typeof(this.$route.query.departId) !=undefined ) {
        this.department = this.$route.query.departId
      }

      this.getDepartMent()
    },
    activated() {
      this.getAdmin()
      let date = new Date()
      this.year = date.getFullYear()
      // 获取token
      let access_token = this.$store.state.token;
      // 获取token
      let token_type = this.$store.state.token_type;
      this.myHeaders = { authorization: token_type + " " + access_token };
    },
    methods:{

      getDepartMent(){
        this.gets('oasystem/departmentlist').then(res=>{
          this.departmentList = res.data.data
        })
      },

      handleEdit(id){
        let ids = id?id:''
        this.$router.push({
          path:'/oaadminEdit?uid='+ids
        })
      },

      clearQuery(){
        this.oatype = ''
        this.oastatus =''
        this.department = ""
        this.page = 1;
        this.getAdmin()
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
          let sHeight = val;
          let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
          this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
        //类型查找
        searchResume(){
          if(!this.key_type){return Message.warning('请选择搜索类型')}
          this.page = 1
          this.getAdmin()
        },
        //全部列表
        getAdmin(){
          this.gets('oasystem/adminlist',
          {oatype:this.oatype,key:this.key,key_type:this.key_type,
          oastatus:this.oastatus,department:this.department,page:this.page
          })
          .then(res=>{
            this.adminList = res.data.data.list;
            this.total = res.data.data.total
            })
        },

        //翻页
        handleCurrentChange(val){
        this.page = val
          this.getAdmin()

        },
        selectChange(){this.$forceUpdate()},

       handleSelectionChange(val){
         let array = []
         array = val.map((item)=>{array.push(item.id);return array})
         this.selectId = array[array.length-1]
       },

      goEnterprisePosition(item) {
        this.$router.push({
          path:'/enterprisePosition?name='+item.oajobname +'&department='+item.department
        })
      }
    }
  }
</script>

<style scoped>
  .content{padding:20px 0px;box-sizing: border-box;width: 100%;}
  .pagination{margin:20px auto;width: 100%;text-align: center;}
  .screen{display: flex;position: relative;}
  .screenList{display: flex;margin: 30px 0 10px;}
  .screenList .listItem{margin-right:40px;display: flex;height: 40px;align-items: center;}
  .screen>>>.el-select{width: 100px;}
  .screenList>>>.el-select{width: 150px;}
  .screenTime{display: flex;margin: 20px 0;}
  .screenTime .items1{display: flex;margin-right: 30px;height: 45px;align-items: center;}
  .remarks{margin: 10px 0;}
  .remarks .title{margin-bottom: 10px;}
  .funtion{margin: 20px 0;background-color: #fff;padding: 20px ;}
  .resumeType{display: flex;height: 45px;align-items: center;font-size: 20px;}
  #app>>>.el-dialog{max-width: 1000px;}
  .btn>.el-button{margin: 5px 0;}
  .contents{display: flex;}
  .contents .items{margin: 20px;width: 100px;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/oasystemadminlist.vue